<template>
  <div
    v-if="showWhenZero || count > 0 || loading"
    class="d-flex align-center gap-120 pa-3"
    :style="cardStyle"
    data-testid="common-count-card"
  >
    <template v-if="loading">
      <v-skeleton-loader
        type="text"
        width="150"
        height="15"
        class="mx-auto"
        data-testid="common-count-card__label-skeleton"
      ></v-skeleton-loader>
      <v-skeleton-loader
        type="text"
        width="60"
        height="15"
        class="mx-auto"
        data-testid="common-count-card__value-skeleton"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <h6
        class="font-weight-medium"
        data-testid="common-count-card__label"
      >
        {{ computedLabel }}
      </h6>

      <h3
        class="font-weight-semibold count-number"
        data-testid="common-count-card__value"
      >
        {{ count }}
      </h3>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CommonCountCard',

  props: {
    /* Count value */
    count: {
      type: Number,
      required: true,
      default: 0,
    },

    /* Label config */
    pageName: {
      type: String,
      required: true,
    },
    labelKey: {
      type: String,
      required: true,
    },
    fallbackLabel: {
      type: String,
      default: '',
    },

    /* Style props */
    borderColor: {
      type: String,
      default: '#B2B2B4',
    },
    backgroundColor: {
      type: String,
      default: '#F7F7F7',
    },
    height: {
      type: String,
      default: '44px',
    },
    borderRadius: {
      type: String,
      default: '8px',
    },

    /* Behaviour */
    showWhenZero: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: null,
    },
  },

  computed: {
    computedLabel() {
      return this.$nova.labelsName(
        this.pageName,
        this.labelKey,
        this.fallbackLabel
      );
    },

    cardStyle() {
      return {
        width: 'fit-content',
        height: this.height,
        borderRadius: this.borderRadius,
        border: `1px solid ${this.borderColor}`,
        background: this.backgroundColor,
        color: this.color || '#2C2C35',
      };
    },
  },
};
</script>

<style scoped>
.count-number {
  color: var(--grey-500);
}
</style>